<div class="preferences-wrapper">
  <nz-tabset
    nzTabPosition="left"
    [(nzSelectedIndex)]="activeTabIndex"
    [nzTabBarStyle]="{ 'width': '220px', 'border-right': '1px solid #f0f0f0' }">

    <!-- ── Itinerary Settings ── -->
    <nz-tab [nzTitle]="'settings.preferences.tabs.itinerarySettings' | transloco"
      *appHasAnyPrivilege="'SETTING.PREFERENCES.ITINERARY.SETTINGS'">
      <ng-template nz-tab>
        <div class="content-panel">
          <h6 class="panel-title">{{ 'settings.preferences.tabs.itinerarySettings' | transloco }}</h6>
          <app-itinerary-settings></app-itinerary-settings>
        </div>
      </ng-template>
    </nz-tab>

    <!-- ── Tour Costing ── -->
    <nz-tab [nzTitle]="'settings.preferences.tabs.tourCosting' | transloco"
      *appHasAnyPrivilege="'SETTING.PREFERENCES.TOUR.COSTING'">
      <ng-template nz-tab>
        <div class="content-panel">
          <h6 class="panel-title">{{ 'settings.preferences.tabs.tourCosting' | transloco }}</h6>
          <app-tour-costing></app-tour-costing>
        </div>
      </ng-template>
    </nz-tab>

    <!-- ── Notifications ── -->
    <nz-tab [nzTitle]="'settings.preferences.tabs.notifications' | transloco"
      *appHasAnyPrivilege="'SETTING.PREFERENCES.NOTIFICATIONS'">
      <ng-template nz-tab>
        <div class="content-panel">
          <h6 class="panel-title">{{ 'settings.preferences.tabs.notifications' | transloco }}</h6>
          <app-pref-notifications></app-pref-notifications>
        </div>
      </ng-template>
    </nz-tab>

    <!-- ── Categories ── -->
    <nz-tab [nzTitle]="'settings.preferences.tabs.categories' | transloco"
      *appHasAnyPrivilege="'SETTING.PREFERENCES.CATEGORIES'">
      <ng-template nz-tab>
        <div class="content-panel">
          <h6 class="panel-title">{{ 'settings.preferences.tabs.categories' | transloco }}</h6>
          <app-pref-categories></app-pref-categories>
        </div>
      </ng-template>
    </nz-tab>

    <!-- ── Custom Domain ── -->
    <nz-tab [nzTitle]="'settings.preferences.tabs.customDomain' | transloco"
      *appHasAnyPrivilege="'SETTING.PREFERENCES.CUSTOM.DOMAIN'">
      <ng-template nz-tab>
        <div class="content-panel">
          <h6 class="panel-title">{{ 'settings.preferences.tabs.customDomain' | transloco }}</h6>
          <app-custom-domain></app-custom-domain>
        </div>
      </ng-template>
    </nz-tab>

  </nz-tabset>
</div>
